import {
  AWXActivityEventType,
  AWXCardActivityEventStatus,
  AWXConnectedAccountTransferActivityEventStatus,
} from '@ankor-io/common/types/transaction/transaction'

export const getPaymentStatusIcon = (transactionAwxActivityEventType: AWXActivityEventType) => {
  switch (transactionAwxActivityEventType) {
    case AWXActivityEventType.CARD_TRANSACTION:
      return '💳'
    case AWXActivityEventType.DEPOSIT:
      return '💰'
    case AWXActivityEventType.TRANSFER:
    case AWXActivityEventType.CONNECTED_ACCOUNT_TRANSFER:
      return '💸'
  }
}

export const getCardPaymentStatusColour = (awxActivityEventStatus: AWXCardActivityEventStatus) => {
  switch (awxActivityEventStatus) {
    case AWXCardActivityEventStatus.SUCCEEDED:
      return 'green'
    case AWXCardActivityEventStatus.FAILED:
      return 'red'
    case AWXCardActivityEventStatus.PENDING:
      return 'yellow'
    case AWXCardActivityEventStatus.REFUNDED:
      return 'gray'
  }
}

export const getCardPaymentStatusText = (awxActivityEventStatus: AWXCardActivityEventStatus) => {
  switch (awxActivityEventStatus) {
    case AWXCardActivityEventStatus.SUCCEEDED:
      return 'Success'
    case AWXCardActivityEventStatus.FAILED:
      return 'Failed'
    case AWXCardActivityEventStatus.PENDING:
      return 'Pending'
    case AWXCardActivityEventStatus.REFUNDED:
      return 'Refunded'
  }
}

export const getConnectedAccountTransferPaymentStatusColour = (
  awxActivityEventStatus: AWXConnectedAccountTransferActivityEventStatus,
) => {
  switch (awxActivityEventStatus) {
    case AWXConnectedAccountTransferActivityEventStatus.SETTLED:
      return 'green'
    case AWXConnectedAccountTransferActivityEventStatus.NEW:
    case AWXConnectedAccountTransferActivityEventStatus.PENDING:
      return 'orange'
    case AWXConnectedAccountTransferActivityEventStatus.SUSPENDED:
    case AWXConnectedAccountTransferActivityEventStatus.FAILED:
      return 'red'
  }
}
